var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBubbleChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2C2359E7-C964-46A7-9863-7FB0DA2A7EB8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.9,28.7982 L10.1772326,28.8020042 C15.5190901,28.9487816 19.8,33.3242542 19.8,38.6982 L19.8,38.6982 L19.7961988,38.9754342 C19.6495384,44.3173506 15.2774847,48.6 9.9,48.6 L9.9,48.6 L9.62285583,48.5961973 C4.28264935,48.4494779 0,44.0756847 0,38.6982 C0,33.2316 4.4316,28.7982 9.9,28.7982 L9.9,28.7982 Z M18.9,0 L19.1477083,0.00371200274 C23.5078235,0.134558025 27,3.70806667 27,8.1 L27,8.1 L26.996288,8.34761197 C26.865442,12.7060895 23.2919333,16.2 18.9,16.2 L18.9,16.2 L18.652388,16.1962862 C14.2939105,16.0653765 10.8,12.4901667 10.8,8.1 C10.8,3.6252 14.427,0 18.9,0 L18.9,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,34.2 L9.26541585,34.2038361 C14.1141869,34.3441722 18,38.3171786 18,43.2 L18,43.2 L17.9961639,43.4654159 C17.8558278,48.3141869 13.8828214,52.2 9,52.2 L9,52.2 L8.73458415,52.1961639 C3.88581314,52.0558278 0,48.0828214 0,43.2 C0,38.2284 4.0284,34.2 9,34.2 L9,34.2 Z M15.3018,4.25862668e-14 L15.6178847,0.0032002207 C23.9211548,0.171475313 30.6,6.9546375 30.6,15.3 L30.6,15.3 L30.5967998,15.6160847 C30.428525,23.9193548 23.645385,30.5982 15.3018,30.5982 L15.3018,30.5982 L14.9856478,30.5949998 C6.68060044,30.426725 0,23.643585 0,15.3 C0,6.849 6.8508,4.25862668e-14 15.3018,4.25862668e-14 L15.3018,4.25862668e-14 Z M43.2,19.8 L43.3912625,19.8049877 C45.2912591,19.9043288 46.8,21.4751613 46.8,23.4 L46.8,23.4 L46.7950123,23.5910993 C46.6956712,25.4895734 45.1248387,27 43.2,27 L43.2,27 L43.0089062,26.9950068 C41.1105409,26.8955588 39.6018,25.3230968 39.6018,23.4 C39.6018,21.411 41.2128,19.8 43.2,19.8 L43.2,19.8 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-Page-Builder-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.1-WebPageBuilder-EmptyWidgets",
    transform: "translate(-1219.000000, -322.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Map-Copy-4",
    transform: "translate(1077.000000, 152.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(30.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Builder/Bubble-Chart/40dp",
    transform: "translate(112.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purple-Light",
    transform: "translate(36.000000, 10.800000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#ACA6FF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Light",
    mask: "url(#mask-2)",
    fill: "#E5E5E5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-36.000000, -10.800000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 115.2,
    height: 115.2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Purple-",
    transform: "translate(10.800000, 10.800000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Light",
    mask: "url(#mask-4)",
    fill: "#E5E5E5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.800000, -10.800000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 115.2,
    height: 115.2
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleChart);
export default __webpack_public_path__ + "static/media/bubbleChart.1a710fe196521d4729f6dbd85511fdcd.svg";
export { ForwardRef as ReactComponent };